// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.ttmwallet",
    name: "MDAO Wallet",
    homepage: "https://ttmwallet.io/",
    image_id: "82014e92-838b-4e75-e77e-76cdc5539d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/ru/app/ttm-wallet/id1540851562",
        android: "https://play.google.com/store/apps/details?id=com.ttmbank.wallet.app&hl=ru&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "ttmwalletapp://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map